import { useEffect, useState } from 'react';

import { FlowsGetItemResponseT } from 'hocs/flows/api/types';

import { FlowMessengerAction } from '../flow.types';

type UseFlowData = {
  actions: FlowMessengerAction[] | null;
  active: boolean;
  messengerId: string | undefined;
  setActions: (actions: FlowMessengerAction[] | null) => void;
  setActive: (active: boolean) => void;
};

export function useFlowData(
  getFlowItem: (
    flowId: string,
  ) => Promise<FlowsGetItemResponseT<FlowMessengerAction>>,
  flowId?: string,
): UseFlowData {
  const [actions, setActions] = useState<null | FlowMessengerAction[]>(null);
  const [active, setActive] = useState(true);
  const [messengerId, setMessengerId] = useState<string | undefined>();

  useEffect(() => {
    if (!flowId) return;
    getFlowItem(flowId).then((res) => {
      setActions(res.data.actions);
      setActive(res.data.active);
      setMessengerId(res.data.location);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flowId]);

  return { actions, active, messengerId, setActions, setActive };
}
